// @flow
import React from 'react';
import moment from 'moment';

import { ICONS } from 'Components/utils/icon/icons';
import { TravelDetail } from 'Components/widgets/travel-details/travel-detail/TravelDetail.jsx';

type Props = {
  departureDate: string,
  returnDate: string,
  dateFormat: string,
  fromLabel: string,
  toLabel: string,
};

const INITIAL_DATE_FORMAT = 'YYYYMMDD';

export default function DurationTravelDetails(props: Props) {
  const { departureDate, returnDate, dateFormat, fromLabel, toLabel } = props;

  return departureDate && returnDate ? (
    <TravelDetail
      infos={{
        text1: fromLabel,
        highlightText1: moment(departureDate, INITIAL_DATE_FORMAT).format(dateFormat),
        text2: toLabel,
        highlightText2: moment(returnDate, INITIAL_DATE_FORMAT).format(dateFormat),
      }}
      icon={ICONS.DATE}
    />
  ) : null;
}
